import { useEffect, useState } from "react";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import { Popup } from "../Popup/Popup";
import { SelectInputData, SelectInputField } from "../SelectInputField/SelectInputField";
import { Text } from "../Text/Text";

interface MultiSelectPopupProps {
  id: string;
  title: string;
  placeholder: string | undefined;
  options: { key: string; title: string }[] | Promise<{ key: string; title: string }[]>;
  didSelect: (keys: string[]) => void;
  defaultSelected?: string[];
  label?: string;
}
export const MultiSelectPopup = (props: MultiSelectPopupProps) => {
  const [options, setOptions] = useState<{ key: string; title: string }[]>([]);
  const [selected, setSelected] = useState<string[]>(props.defaultSelected ?? []);

  useEffect(() => {
    if (Array.isArray(props.options)) {
      setOptions(props.options);
    } else {
      props.options.then((options) => setOptions(options));
    }
  });

  return (
    <ModalPopup
      id={props.id}
      title={props.title}
      disableAction={selected === undefined}
      onActionClicked={() => {
        if (selected) {
          Popup.remove(props.id);
          props.didSelect(selected);
        }
      }}
      children={
        <div>
          {props.label && <Text text={props.label} textAlign="left" marginBottom={16} />}
          <SelectInputField
            placeholder={props.placeholder}
            options={options.map((option) => new SelectInputData(option.key, option.title))}
            onChange={(selectedOption) => selectedOption && setSelected(selectedOption.map((option) => option.value))}
            value={selected}
            multi
            width="100%"
            menuPortalTarget="popup"
          />
        </div>
      }
    />
  );
};

